import { RicosPluginToolbarNames } from 'ricos-types';
import type { EditorPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS_CONFIG } from './defaults';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { tiptapExtensions } from './tiptap/tiptap';
import { InsertModal } from './toolbar/insert-modal/InsertModal';
import { SliderModal } from './toolbar/SliderModal';
import type { HtmlPluginEditorConfig } from './types';
import { HTML_TYPE } from './types';

export const pluginHtml: EditorPluginCreator<
  HtmlPluginEditorConfig,
  {
    InsertModal: typeof InsertModal;
    SliderModal: typeof SliderModal;
  }
> = config => {
  const pluginConfig: HtmlPluginEditorConfig = { ...DEFAULTS_CONFIG, ...config };
  return {
    config: pluginConfig,
    type: HTML_TYPE,
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.HTML],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    __exports: {
      InsertModal,
      SliderModal,
    },
  };
};
